export const B2B_SET_TRANSLATION_ACTION = 'B2B_SET_TRANSLATION_ACTION';

export const setTranslationsAction = ( translations ) => {

    return {
        type: B2B_SET_TRANSLATION_ACTION,
        payload: translations
    };

};